import {
    formatDateNoTime,
    formatYDM,
    getToken,
    getToken2,
    getUser,
    numberFormatInt
} from "../../Utils/Common";
import Moment from "moment";
import { getAPICall, postAPICall } from "../axiosMethodCalls";

export const getWastage = async (id, status) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "wastages/get_wastage",
            {
                requester: getUser(),
                token: getToken(),
                wastage_id: id,
                payment_status: status,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const getAllWastage = async () => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "wastages/get_all_wastage",
            {
                requester: getUser(),
                token: getToken(),
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const updateWastageStatus = async (id, status) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "wastage_items/change_status",
            {
                requester: getUser(),
                token: getToken(),
                wastage_item_id: id,
                // amount: amount,
                status: status,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};


export const searchWastage = async (data) => {
    const date = new Date();
    date.setDate(date.getDate() - 7);

    const nextDay = new Date();
    nextDay.setDate(nextDay.getDate() + 1);
    

    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "wastages/search",
            {
                requester: getUser(),
                token: getToken(),
                branch_id: data.branch_id,
                branch_name: data.branch_name,
                item_id: data.item_id,
                wastage_date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : Moment(date).format("YYYY-MM-DD"),
                wastage_date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : Moment(nextDay).format("YYYY-MM-DD"),
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};


export const searchWastageByDate = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "wastages/search",
            {
                requester: getUser(),
                token: getToken(),
                branch_id: data.branch_id,
                branch_name: data.branch_name,
                item_id: data.item_id,
                wastage_date_from: data.date ? Moment(data.date).format("YYYY-MM-DD") : Moment().format("YYYY-MM-DD"),
                wastage_date_to: data.date ? Moment(data.date).format("YYYY-MM-DD") : Moment().format("YYYY-MM-DD"),
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const deleteWastage = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "wastages/delete",
            {
                requester: getUser(),
                token: getToken(),
                wastage_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

// -------------------POTATO-----------------------

export const searchWastagePotato = async (data) => {
    const date = new Date();
    date.setDate(date.getDate() - 7);

    const nextDay = new Date();
    nextDay.setDate(nextDay.getDate() + 1);
    

    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "wastages/search",
            {
                requester: getUser(),
                token: getToken2(),
                branch_id: data.branch_id,
                branch_name: data.branch_name,
                item_id: data.item_id,
                wastage_date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : Moment(date).format("YYYY-MM-DD"),
                wastage_date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : Moment(nextDay).format("YYYY-MM-DD"),
            }, "potato"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const getWastagePotato = async (id, status) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "wastages/get_wastage",
            {
                requester: getUser(),
                token: getToken2(),
                wastage_id: id,
                payment_status: status,
            }, "potato"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const deleteWastagePotato = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "wastages/delete",
            {
                requester: getUser(),
                token: getToken2(),
                wastage_id: id,
            }, "potato"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};


export const searchWastageByDatePotato = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "wastages/search",
            {
                requester: getUser(),
                token: getToken2(),
                branch_id: data.branch_id,
                branch_name: data.branch_name,
                item_id: data.item_id,
                wastage_date_from: data.date ? Moment(data.date).format("YYYY-MM-DD") : Moment().format("YYYY-MM-DD"),
                wastage_date_to: data.date ? Moment(data.date).format("YYYY-MM-DD") : Moment().format("YYYY-MM-DD"),
            }, "potato"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const updateWastageStatusPotato = async (id, status) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "wastage_items/change_status",
            {
                requester: getUser(),
                token: getToken2(),
                wastage_item_id: id,
                // amount: amount,
                status: status,
            }, "potato"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};
